(function () {
  const LOG = (...a) => { try { console.log('[UmmamiNav]', ...a); } catch(e){} };

  // CHANGE THIS to your actual section ID
  const TARGET_SECTION_ID = 'shopify-section-template--17024814055493__slideshow_PMRHcK';

  const TEXT_SELECTORS = [
    '.banner__content .banner__box',
    '.banner__content',
    '.slideshow__content',
    '.slideshow__text',
    '.slideshow__text-wrapper',
    '.banner__box'
  ];

  const OVERLAY_SELECTORS = [
    '.banner__media-link',
    '.slideshow__link',
    'a.full-unstyled-link',
    '.banner__content > a'
  ].join(',');

  function $all(root, sel) { return Array.from((root || document).querySelectorAll(sel)); }

  function findTextContainer(slide) {
    for (const sel of TEXT_SELECTORS) {
      const el = slide.querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  function ensureNav(container) {
    let nav = container.querySelector('.ummami-nav');
    if (nav) return nav;
    nav = document.createElement('div');
    nav.className = 'ummami-nav';
    nav.innerHTML = `
      <button class="ummami-prev" aria-label="Previous" type="button">←</button>
      <button class="ummami-next" aria-label="Next" type="button">→</button>
    `;
    // Safety: make sure the pill can sit above overlays even if theme z-index is high
    nav.style.position = 'relative';
    nav.style.zIndex = '2147483647'; // max-ish
    nav.style.pointerEvents = 'auto';
    container.appendChild(nav);
    return nav;
  }

  function bindNav(btn, fn) {
    ['pointerdown','touchstart','click'].forEach(evt => {
      btn.addEventListener(evt, (e) => {
        e.preventDefault();
        e.stopPropagation();
        fn();
      }, { passive: false });
    });
  }

  // If a full-cover link/overlay is physically on top of the pill, disable its pointer-events
  function unblockIfCovered(nav) {
    try {
      const r = nav.getBoundingClientRect();
      if (r.width === 0 || r.height === 0) return;
      const x = Math.floor(r.left + r.width / 2);
      const y = Math.floor(r.top + r.height / 2);
      const topEl = document.elementFromPoint(x, y);
      if (!topEl || nav.contains(topEl)) return;

      const blocker = topEl.closest(OVERLAY_SELECTORS);
      if (blocker) {
        blocker.dataset._ummamiPointerEvents = blocker.style.pointerEvents || '';
        blocker.style.pointerEvents = 'none';
        LOG('Disabled overlay pointer-events for', blocker);
      }
    } catch (e) {
      // ignore
    }
  }

  function injectIntoSlideshow(slideshow) {
    const slides = $all(slideshow, '.slideshow__slide, .slider__slide, [id^="Slide-"]');
    LOG('slides', slides.length);

    slides.forEach((slide, i) => {
      const text = findTextContainer(slide) || slide;
      const nav = ensureNav(text);

      // Re-query actual controls on every click so we don't keep stale/disabled refs
      bindNav(nav.querySelector('.ummami-prev'), () => {
        const realPrev =
          slideshow.querySelector('[name="previous"], .slider-button--prev, button[aria-label*="Previous"]');
        if (realPrev && !realPrev.disabled) realPrev.click();
        else fallbackClick(slideshow, -1);
      });

      bindNav(nav.querySelector('.ummami-next'), () => {
        const realNext =
          slideshow.querySelector('[name="next"], .slider-button--next, button[aria-label*="Next"]');
        if (realNext && !realNext.disabled) realNext.click();
        else fallbackClick(slideshow, +1);
      });

      // After layout paints, check if something sits on top of the pill; if so, neutralize it.
      requestAnimationFrame(() => unblockIfCovered(nav));

      LOG(`nav injected into slide ${i}`, 'text container?', text !== slide);
    });
  }

  function fallbackClick(slideshow, dir = 1) {
    const dots = $all(slideshow, '.slider-counter__link, .slideshow__control-dot, [data-slide-dot]');
    if (!dots.length) return;
    const active = dots.findIndex(d =>
      d.classList.contains('is-active') ||
      d.getAttribute('aria-current') === 'true' ||
      d.getAttribute('aria-selected') === 'true'
    );
    const cur = active >= 0 ? active : 0;
    const target = (cur + dir + dots.length) % dots.length;
    dots[target].dispatchEvent(new MouseEvent('click', { bubbles: true }));
  }

  function init() {
    const section = document.getElementById(TARGET_SECTION_ID);
    if (!section) { LOG('Target section not found'); return; }
    injectIntoSlideshow(section);
  }

  document.addEventListener('DOMContentLoaded', () => { LOG('loaded'); init(); });
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.id === TARGET_SECTION_ID) {
      LOG('section:load matched');
      injectIntoSlideshow(e.target);
    }
  });
})();
